export default __webpack_public_path__ + "static/media/akros-logo.0e660f85.png";